import { SocketClient } from "cbcore-ts"
import { UIColor, UIRoute, UITextView, UIView, UIViewController } from "uicore-ts"
import { RHProcurement } from "../../prodModels"
import { CBDataView } from "./Custom components/CBDataView"
import { RHButton } from "./Custom components/RH/RHButton"
import { RHColor } from "./Custom components/RH/RHColor"
import { NewProcurementViewController } from "./NewProcurementViewController"


export class ProcurerMainViewController extends UIViewController {
    
    readonly titleLabel: UITextView = new UITextView(
        this.view.elementID + "TitleLabel",
        UITextView.type.header2
    ).configuredWithObject({
        text: "Hankija esileht",
        hoverText: "",
        backgroundColor: UIColor.transparentColor
    }).addedAsSubviewToView(this.view)
    
    explanationView: UITextView = new UITextView().addedAsSubviewToView(this.view).configuredWithObject({
        text: "Tere, hankija."
    })
    
    newProcurementButton = new RHButton().addedAsSubviewToView(this.view).configuredWithObject({
        titleLabel: {
            text: "Start new procurement"
        },
        controlEventTargetAccumulator: {
            // @ts-ignore
            PointerUpInside: {
                EnterDown: async (sender, event) => {
                    
                    UIRoute.currentRoute
                        .routeByRemovingComponentNamed(ProcurerMainViewController.routeComponentName)
                        .routeWithViewControllerComponent(NewProcurementViewController, {})
                        .apply()
                    
                    
                }
            }
        }
    })
    
    
    procurementsDataView = new CBDataView().addedAsSubviewToView(this.view)
        .configuredWithObject({
            
            descriptors: [
                {
                    title: "Title",
                    keyPath: "title"
                },
                {
                    title: "ID",
                    keyPath: "_id",
                    buttonWasPressed: (cellView: UIView, dataItem: RHProcurement, event: Event) => UIRoute.currentRoute
                        .routeByRemovingComponentNamed(ProcurerMainViewController.routeComponentName)
                        .routeBySettingParameterInComponent(
                            NewProcurementViewController.routeComponentName,
                            NewProcurementViewController.ParameterIdentifierName.id,
                            dataItem._id!
                        ).apply()
                }
            ]
            
        })
    
    
    bottomView = new UIView().addedAsSubviewToView(this.view)
    
    constructor(view: UIView) {
        
        super(view)
        
        // Code for further setup if necessary
        
        this.view.configureWithObject({
            backgroundColor: RHColor.backgroundColor
        })
        
    }
    
    
    static override readonly routeComponentName = "procurer_main"
    
    static override readonly ParameterIdentifierName = {}
    
    override async viewDidAppear() {
        
        const data = (await SocketClient.RetrieveProcurementsListForCurrentProcurerUser()).result
        this.procurementsDataView.data = data
        
    }
    
    
    override async handleRoute(route: UIRoute) {
        
        super.handleRoute(route)
        const inquiryComponent = route.componentWithName(ProcurerMainViewController.routeComponentName)
        
    }
    
    
    override updateViewConstraints() {
        
        super.updateViewConstraints()
        
    }
    
    
    override updateViewStyles() {
        
        super.updateViewStyles()
        
    }
    
    
    override viewDidLayoutSubviews() {
        
        super.viewDidLayoutSubviews()
        
    }
    
    
    override layoutViewSubviews() {
        
        super.layoutViewSubviews()
        
        const padding = this.core.paddingLength
        const labelHeight = padding
        
        // View bounds
        const bounds = this.view.bounds.rectangleWithInset(padding)
        
        this.titleLabel.frame = bounds.rectangleWithHeight(labelHeight * 2)
        this.explanationView.frame = this.titleLabel.frame.rectangleForNextRow(
            padding,
            [this.explanationView.intrinsicContentHeight(this.titleLabel.frame.width), padding].max()
        )
        
        this.newProcurementButton.frame = this.explanationView.frame.rectangleForNextRow(padding, padding * 2)
        
        this.procurementsDataView.frame = this.newProcurementButton.frame.rectangleForNextRow(padding * 2, 800)
        
        this.bottomView.frame = this.newProcurementButton.frame.rectangleForNextRow(
            padding,
            [this.bottomView.intrinsicContentHeight(this.newProcurementButton.frame.width), padding].max()
        )
        
    }
}
